/**
 * Centrala JSON-LD-scheman för SEO (schema.org).
 * Används av <Seo jsonLd={...} /> på publika sidor för att hjälpa
 * Google och AI-crawlers att förstå innehållet.
 */
import { FAQ_ITEMS } from "@/lib/citizen";

const SITE = "https://bygglovkollen.se";

export const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Bygglovskompassen",
  alternateName: "Bygglovskompassen.se",
  url: SITE,
  logo: `${SITE}/logo512.png`,
  description:
    "Gratis AI-driven e-tjänst som hjälper svenska medborgare att förstå, planera och sammanställa bygglovsansökan enligt PBL/BBR.",
  areaServed: { "@type": "Country", name: "Sverige" },
  inLanguage: "sv-SE",
  sameAs: [],
};

export const websiteJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Bygglovskompassen",
  url: SITE,
  inLanguage: "sv-SE",
  potentialAction: {
    "@type": "SearchAction",
    target: `${SITE}/chat?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

export const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQ_ITEMS.map((it) => ({
    "@type": "Question",
    name: it.q,
    acceptedAnswer: {
      "@type": "Answer",
      text: it.a,
    },
  })),
};

/** Slår ihop flera JSON-LD-objekt till en @graph för att kunna injicera flera scheman på en sida. */
export function combineJsonLd(...schemas) {
  return {
    "@context": "https://schema.org",
    "@graph": schemas.filter(Boolean).map((s) => {
      const { "@context": _ctx, ...rest } = s;
      return rest;
    }),
  };
}
